import React, { useEffect, useState, useRef } from 'react';
import { useTenancy } from '@/contexts/TenancyContext';
import { db } from '@/js/external-js/config/main_config';

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';
import { Separator } from "@/components/ui/separator"

import EditableField from '@/components/ui/EditableField';
import { FrameworkBadge } from '@/app/pages/msg/components/FrameworkBadge';
import { getAllModules } from '@/app/pages/msg/utils/common';
import { fetchRelatedDocuments, populateCustomContent, fetchPageContentMDX } from '@/app/pages/msg/utils/common';
import { useMarkdownComponents } from '@/app/pages/msg/components/MDXFields';
import { MarkdownRenderer } from '../../components/MarkdownRenderer';
import RelatedClausesAccordianItem from '../../components/RelatedClauses';
import AdditionalContent from '../../components/AdditionalContent';
import FootNote from '../../components/FootNote';
import SupportingDocs from '../../components/SupportingDocs';
import SupportingDocsDropdown from '../../components/SupportingDocsDropdown';

export default function RiskTreatmentSection() {
  const { activeTenancy } = useTenancy();

  const clauseStandards = useRef<Set<string>>(new Set());
  const [pageClauses, setPageClauses] = useState<Set<string>>(new Set());
  const updatePageClauses = (newClauses: Set<string>) => {
    setPageClauses(new Set(newClauses));
  };

  const [pageTemplate, setPageTemplate] = React.useState<string>('');
  const [supportingDocs, setSupportingDocs] = React.useState([]);
  const [sortedFrameworks, setSortedFrameworks] = React.useState([]);
  const [dynamicStandardNames, setDynamicStandardNames] = useState<Map<string, string>>(new Map());
  const [dynamicContent, setDynamicContent] = React.useState<string>("");

  const [modulesList, setModulesList] = useState([]);
  const pageName = 'planning';
  const contentPath = ['riskTreatment'];
  const pageRoute = '/MSG/planning/riskTreatment';

  useEffect(() => {
    if (activeTenancy.id == "") return;

    const pageContent = fetchPageContentMDX(db, pageName, contentPath, activeTenancy, setPageTemplate);

    // const getRelatedDocuments = fetchRelatedDocuments(db, activeTenancy.id, pageRoute, setSupportingDocs);

    // From src/components/relatedControls.component:195
    // const popStandardsList = populateStandardsList(db, pageName, contentPath, setDynamicStandardNames, setSortedFrameworks);

    // New function to populate the contents from the customer
    const getCustomContent = populateCustomContent(db, activeTenancy.id, pageRoute, setDynamicContent);


    const load = async () => {
      const loadModules = async () => {
        const allModules = await getAllModules();
        const storedVisibilities = JSON.parse(localStorage.getItem('modulesVisibility') || '{}');

        allModules.forEach(module => {
          module.visible = storedVisibilities[module.id] ?? false;
        });

        setModulesList(allModules);
      }
      loadModules();
    }; load();
    return () => {
      pageContent();
      getCustomContent();
      // getRelatedDocuments();
    };
  }, [activeTenancy]);

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-xl border border-border shadow-sm px-6 py-6 relative">
        <div className="absolute right-4 top-4 z-10">
          <div className="flex items-center space-x-2">
            <SupportingDocsDropdown pageRoute={pageRoute} clauseStandards={clauseStandards} pageClauses={pageClauses} />
            <RelatedClausesAccordianItem modulesList={modulesList} clauseStandards={clauseStandards} setModulesList={setModulesList} />
          </div>
        </div>
        <div className="px-6 py-6">
          <MarkdownRenderer source={pageTemplate} components={useMarkdownComponents(modulesList, clauseStandards, { current: pageClauses }, updatePageClauses)} />
        </div>
        <div style={{ maxWidth: '56rem', marginLeft: 'auto', marginRight: 'auto', padding: '0px 1rem 1.5rem', transition: 'color 0.2s, background-color 0.2s', backgroundColor: 'transparent' }}>
          <AdditionalContent pageRoute={pageRoute} />
          <FootNote />
        </div>
      </div>

      {/* <div className="bg-card rounded-xl border border-border shadow-sm">
        <SupportingDocs pageRoute={pageRoute} clauseStandards={clauseStandards} pageClauses={pageClauses} />
      </div> */}
    </div>
  );
}
